var _defs, _path, _g, _g2, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAtcLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .st0 {\r\n        fill: none;\r\n      }\r\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M66.2,11H18.7c-.6,0-1,.4-1,1v62.6c0,.6.4,1,1,1h47.4c.3,0,.5-.1.7-.3.2-.2.3-.4.3-.7V12c0-.6-.4-1-1-1ZM19.7,13h45.4v60.6H19.7V13Z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 34.4,
    y1: 25.8,
    x2: 50.9,
    y2: 25.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.9,26.8h-16.5c-.6,0-1-.4-1-1s.4-1,1-1h16.5c.6,0,1,.4,1,1s-.4,1-1,1Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 46.6,
    y1: 21.3,
    x2: 50.9,
    y2: 25.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.9,26.6c-.3,0-.5,0-.7-.3l-4.3-4.3c-.4-.4-.4-1,0-1.4s1-.4,1.4,0l4.3,4.3c.4.4.4,1,0,1.4s-.5.3-.7.3Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 50.9,
    y1: 25.9,
    x2: 46.6,
    y2: 30.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.6,31.2c-.3,0-.5,0-.7-.3-.4-.4-.4-1,0-1.4l4.3-4.3c.4-.4,1-.4,1.4,0s.4,1,0,1.4l-4.3,4.3c-.2.2-.5.3-.7.3Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 50.9,
    y1: 35.1,
    x2: 34.4,
    y2: 35.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.9,36.1h-16.5c-.6,0-1-.4-1-1s.4-1,1-1h16.5c.6,0,1,.4,1,1s-.4,1-1,1Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 38.8,
    y1: 39.7,
    x2: 34.4,
    y2: 35.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.8,40.7c-.3,0-.5,0-.7-.3l-4.3-4.3c-.4-.4-.4-1,0-1.4s1-.4,1.4,0l4.3,4.3c.4.4.4,1,0,1.4-.2.2-.5.3-.7.3Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 34.4,
    y1: 35,
    x2: 38.8,
    y2: 30.7
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.4,36c-.3,0-.5,0-.7-.3-.4-.4-.4-1,0-1.4l4.3-4.3c.4-.4,1-.4,1.4,0s.4,1,0,1.4l-4.3,4.3c-.2.2-.5.3-.7.3Z"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M31,50.4h24.1c.6,0,1-.4,1-1s-.4-1-1-1h-24.1c-.6,0-1,.4-1,1s.4,1,1,1Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31,57.3h24.1c.6,0,1-.4,1-1s-.4-1-1-1h-24.1c-.6,0-1,.4-1,1s.4,1,1,1Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55,62.2h-24.1c-.6,0-1,.4-1,1s.4,1,1,1h24.1c.6,0,1-.4,1-1s-.4-1-1-1Z"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M72.9,17.7h-6.7v2h5.7v60.6H26.5v-5.9h-2v6.9c0,.6.4,1,1,1h47.4c.3,0,.5-.1.7-.3.2-.2.3-.4.3-.7V18.7c0-.6-.4-1-1-1Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M79.7,23.9h-6.7v2h5.7v60.6h-45.4v-5.5h-2v6.5c0,.6.4,1,1,1h47.4c.3,0,.5-.1.7-.3.2-.2.3-.4.3-.7V24.9c0-.6-.4-1-1-1Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAtcLogo);
export default __webpack_public_path__ + "static/media/ATC-Logo.6c02e94501f1bed8c6c255234db92b2f.svg";
export { ForwardRef as ReactComponent };